import { render, staticRenderFns } from "./IncomeImportRecords.vue?vue&type=template&id=054fe632&scoped=true"
import script from "./IncomeImportRecords.vue?vue&type=script&lang=js"
export * from "./IncomeImportRecords.vue?vue&type=script&lang=js"
import style0 from "./IncomeImportRecords.vue?vue&type=style&index=0&id=054fe632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054fe632",
  null
  
)

export default component.exports